import * as React from 'react';
import type { SVGProps } from 'react';

export const TrustedShopsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="trusted-shops_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 298 297"
    {...props}
  >
    <style>
      {
        '.trusted-shops_svg__st2,.trusted-shops_svg__st6{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.trusted-shops_svg__st6{fill:#044d73}'
      }
    </style>
    <g id="trusted-shops_svg__Page-1">
      <g
        id="trusted-shops_svg__Trustmark_x5F_sketch_x5F_2021_x5F_v3-01-_x28_1_x29_"
        transform="translate(.6)"
      >
        <radialGradient
          id="trusted-shops_svg__background-circle_1_"
          cx={-155.787}
          cy={543.89}
          r={0.683}
          gradientTransform="matrix(296.2501 0 0 -296.25 46236.98 161209.25)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: '#9b9c9e',
            }}
          />
          <stop
            offset={0.321}
            style={{
              stopColor: '#656667',
            }}
          />
          <stop
            offset={0.785}
            style={{
              stopColor: '#1d1d1d',
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: '#000',
            }}
          />
        </radialGradient>
        <path
          id="trusted-shops_svg__background-circle"
          d="M148.5 0C230.5 0 297 66.5 297 148.5c-7.8 197-289.2 197-297 0C0 66.5 66.5 0 148.5 0m1.2 55.6c-123.3 4.9-123.4 181.2 0 186.1 51.4 0 93.1-41.7 93.1-93.1s-41.8-93-93.1-93"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: 'url(#trusted-shops_svg__background-circle_1_)',
          }}
        />
        <radialGradient
          id="trusted-shops_svg__background-gradient_1_"
          cx={-154.798}
          cy={544.603}
          r={0.9}
          gradientTransform="matrix(119.5871 141.954 141.9539 -119.5872 -58694.535 87191.305)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: '#fffefc',
            }}
          />
          <stop
            offset={0.242}
            style={{
              stopColor: '#fffdf7',
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: '#f1cb54',
            }}
          />
        </radialGradient>
        <path
          id="trusted-shops_svg__background-gradient"
          d="M242.7 148.7c0 51.4-41.7 93.1-93.1 93.1-123.4-4.9-123.3-181.2 0-186.1 51.4-.1 93.1 41.6 93.1 93"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: 'url(#trusted-shops_svg__background-gradient_1_)',
          }}
        />
        <g id="trusted-shops_svg__text" transform="translate(15.7 15.677)">
          <path
            id="trusted-shops_svg__Shape"
            d="m231.5 98.7 9.7-3c.6 3.9 3.1 8.4 6.1 10 3.9 2.5 11.1.2 12.5-4.4 2-3.8-1.9-13.8-3.6-17l-26.6 8.3zm22.3-7c1.6 2.9 2.3 7.4-1.5 8.5-3.6 1.3-6.1-2.4-6.5-6z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Shape_1_"
            d="M219.1 74.9c4.6 6.9 12.3 8.4 20.1 3.3 16.2-10.6.8-33.3-15.5-22.3-6.7 4.5-9.3 12.1-4.6 19m8.4-13.5c4.6-3 9.4-3.2 11.8.4 5.2 7.5-11.2 18.2-15.9 10.6-2.3-3.6-.5-7.9 4.1-11"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path"
            d="m194.1 48.2 7.5-9.2 8.2 6.6-7.5 9.2 5 4L225 36.9l-4.9-4.1-6.8 8.5-8.2-6.6 6.8-8.5-5-4-17.7 22z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_1_"
            d="M172.5 36.7c7.1 3.1 12 .8 13.9-3.5 1.6-3.7.5-7-3.4-10.6-2.8-2.7-3.9-4.1-3.2-5.7.6-1.3 2.3-2 4.9-.9 2.5 1.1 4.1 2.6 4.9 3.6l3.3-4.1c-4.8-5.5-16-8.3-19.2-.6-1.6 3.8.2 7.4 3.8 10.8 2.7 2.4 3.5 3.9 2.8 5.5-1.9 4.4-9.6-1.1-11.1-3.4l-3.3 4.3c1 1.2 3.6 3.3 6.6 4.6"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Shape_2_"
            d="M143.5 3.2C139.6-.5 129-.4 123.4.5l-.5 27.7c5.7 1 16.1 1 20.4-2.9 5.8-4.4 6.8-17.5.2-22.1m-12 20.5c-.8 0-1.7 0-2.2-.2l.3-18.5c6.2-1.1 12 1.6 11.7 8.9-.1 6.9-4 10-9.8 9.8"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_2_"
            d="m115.9 29.4-1.3-5.1-11.2 2.9-1.7-6.5 10.1-2.6-1.3-5-10.1 2.6-1.5-5.7 10.7-2.8-1.3-5.1-16.8 4.4 7 27.4z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_3_"
            d="m69.3 22.5 10.9 20.1 5.6-3.1-10.9-20.1 6.8-3.7-2.6-4.7L60 21.4l2.6 4.7z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_4_"
            d="M53.2 48.2c3.3-1.4 5-1.6 6.2-.3 3.2 3.6-4.9 8.3-7.6 8.8l2.6 4.7c1.8-.4 4.7-1.9 7.1-4.1 5.7-5.2 5.7-10.6 2.5-14.1-2.7-2.9-6.1-3.3-11.1-1.3-3.7 1.5-5.3 1.9-6.6.6-2.7-3.1 4.3-7.4 6.4-7.8L50.3 30c-7 2.1-14.1 11.2-8.4 17.3 2.7 3 6.7 2.8 11.3.9"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_5_"
            d="M44.6 77.9c3.9-6.2 2.7-12.2-4.6-16.8l-13.4-8.4-3.4 5.4 13.7 8.6c4.3 2.7 5.3 5.5 3.5 8.3-1.7 2.7-4.8 3-9 .4l-13.7-8.6-3.4 5.4 13.3 8.4c7.7 4.7 13.2 3.3 17-2.7"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Shape_3_"
            d="m31.6 107-10.7-3.1.5-1.8c.8-2.5 2-3.4 5.6-3.2s5.9.1 6.9 0l1.8-6.3c-1.2.2-5 0-8.3 0-2.7 0-4.8.5-6.1 2.2h-.1c-.2-5.4-6.9-9.2-11.7-5.8-3.8 2.3-5.9 12.3-6.5 16.5l26.8 7.7zm-14.4-6.7-.7 2.4-7.4-2.1c.3-2.9 1.7-7.5 5.6-6.3 2.4.6 3.4 2.9 2.5 6"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_6_"
            d="m28.6 126.8-22.9-.5.2-7.8-5.3-.1-.6 21.7 5.4.1.2-7.6 22.8.6z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_7_"
            d="m34.6 204.7 2.9 4.7-6.9 4.3c-6-4.9-7.3-13.7.7-18.4 8.2-5.4 16.1 1.1 17.3 9.3l2.9-.8c-1.9-10.6-12.7-17.9-22.4-11.6-11.4 7.1-6.9 19.2 1.4 25.6l11.2-6.9-4.8-7.7z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_8_"
            d="m69.8 219.3-10.4 12.5c-3.9 4.6-7.6 5-10.7 2.4-2.8-2.3-3.2-6.1.7-10.7l10.4-12.4-2.7-2.3L46.7 221c-5.5 6.5-4.3 11.7 0 15.3 4.5 3.8 10.1 4 15.5-2.4l10.3-12.2z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Shape_4_"
            d="m64.6 248.8 3.3 1.5 6.1-6.7 8.8 4-.9 9 3.4 1.6 2.8-28.8-3.8-1.7zM85 231.5c-.7 3.1-1.2 10.1-1.6 13.4l-7.5-3.4c2.3-2.5 7.1-7.4 9.1-10"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Shape_5_"
            d="M109.1 235.8c-2.4-.5-4.9-.7-6.8-.8l-5.2 26.5 3.5.7 2.3-11.6 3.3.6c3.1.7 4.3 2.4 4.4 6.3.1 3.5.2 5.9.5 6.8l3.6.7c-.4-1.1-.5-3.9-.6-7.8-.1-2.9-.9-5.1-2.8-6.2v-.1c5.3-.4 8.5-7 5.3-11.4-1.5-1.8-3.8-3-7.5-3.7m4.9 9c-.6 3.1-3.4 4.6-7.1 3.9l-3.5-.7 1.9-9.8c3.9-.1 9.9 1.4 8.7 6.6"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Shape_6_"
            d="m133.4 238.5-9 27.5h3.7l2.7-8.6 9.7-.1 3 8.6 3.8-.1-9.7-27.2zm-1.9 16c1-3.2 3.2-9.7 3.9-12.9h.1c.7 3.1 3.2 9.7 4.3 12.8z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_9_"
            d="M169.3 233.2c1.7 6.3 3.9 16.1 6 21.9l-.1.1c-3.7-4.8-14.2-14.1-18.8-18.6l-3.8 1 6.8 26.4 3.2-.8c-1.6-6.1-4.2-16.7-6-22.2l.1-.1c4 5.1 14.3 14.1 19.1 18.9l3.5-.9-6.8-26.5z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_10_"
            d="m196.1 223.6-1.5-2.6-17.7 9.7 1.4 2.6 7.3-4 11.7 21.4 3.1-1.7-11.7-21.4z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_11_"
            d="m217.4 233.5-6.7-7.3 7.8-7.1-2-2.2-7.8 7.2-5.8-6.4 8.2-7.6-2-2.2-10.9 10.1 18.5 20.1 11.4-10.4-2-2.2z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_12_"
            d="m235.8 213-8.3-5.4 5.8-8.9-2.5-1.5-5.7 8.9-7.3-4.7 6.1-9.5-2.5-1.6-8 12.4 23 14.9 8.3-12.9-2.5-1.7z"
            className="trusted-shops_svg__st2"
          />
          <path
            id="trusted-shops_svg__Path_13_"
            d="M265.7 127.1c-.3-6.6-4.2-10.5-9-10.2-4.1.2-6.5 3.5-8 8.2-1 3.5-1.9 4.8-3.7 4.9-4.8.2-3.3-9.1-1.9-11.5l-5.3-1c-.8 1.6-1.5 4.9-1.3 8.1.4 7.7 4.6 11.1 9.3 10.9 4-.2 6.4-2.7 8-7.7 1.2-3.8 1.9-5.3 3.7-5.4 4.2-.1 3 8 1.9 9.9l5.2 1.2c.7-1.8 1.2-4.1 1.1-7.4"
            className="trusted-shops_svg__st2"
          />
        </g>
        <path
          id="trusted-shops_svg__circle-left"
          d="M38.2 181.4c-.2 6.9-10.2 6.9-10.4 0 .2-6.9 10.2-6.9 10.4 0"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: '#f7e19e',
          }}
        />
        <path
          id="trusted-shops_svg__circle-right"
          d="M268.8 181.4c-.2 6.9-10.2 6.9-10.4 0 .2-6.9 10.2-6.9 10.4 0"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: '#f1cb53',
          }}
        />
        <path
          id="trusted-shops_svg__Shape_7_"
          d="M167.4 87.1c16 0 27.2 7.6 29.3 19.9 1.2 6.6-.3 12.4-2.3 16.9l-.3.6-.3.6-.3.6c-.3.5-.5 1-.8 1.4l-.3.5-.3.5-.3.5c-.1.1-.1.2-.2.2l-.3.5-.3.4-.3.4-.2.2-.3.4-.4.6c0 .1-.1.1-.1.2l-.4.5-.4.4c-6 6.7-15.6 12.4-29.2 17.7l-1.5.6c-9 3.4-18.3 5.8-27.5 7.9l-2.9.7-2.9.6-4.3.9c-.9 21.9 4.7 33.3 17.2 34.9 1.1.1 2.3.2 3.4.2 7.1 0 13.1-2.9 17.8-6l.7-.5.7-.5.7-.5.7-.5 1-.7c6.2-4.9 11.2-10.7 15.3-16.5l1.5-2 6.8 5.9-.4.5-.9 1.3c-.5.7-.9 1.3-1.4 2l-.9 1.3c-5.7 8-11.6 14.6-19.7 19.8l-.7.4c-.1.1-.2.1-.4.2l-.7.4c-.6.4-1.3.8-1.9 1.1l-.8.4-.8.4c-6.6 3.4-15.4 6.5-25.6 6.5-2.4 0-4.9-.2-7.2-.5-18.6-2.7-29.1-16.1-29.4-37.8v-.7c-.2-20 6-38.4 18.6-54.7l.5-.6c13.9-17.8 30.6-26.9 51.1-27.8.2.4.9.3 1.6.3m-6.7 9.7c-.8 0-1.7.1-2.5.2l-.5.1c-8.7 1.5-15 7.1-20 13.8l-.6.8c-.1.1-.2.3-.3.4l-.6.8-.6.8-.6.8-.6.8-.5.8-.5.9-.5.9c-5.8 9.4-9.6 20.2-11.8 33.1 13-2.3 24.7-6.7 33.9-12.7 12.8-8.4 19-18.3 18.5-29.2-.5-7.3-5.6-12.3-12.8-12.3"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: '#006dad',
          }}
        />
        <g id="trusted-shops_svg__shadow" transform="translate(92.695 86)">
          <path
            id="trusted-shops_svg__Path_14_"
            d="M3.5 84.8c-.2-20.3 6-39.3 18.8-55.8 13.8-17.8 31.6-26.4 52-27.3.8 0 1.5-.1 2.2-.1 4.2 0 8.1.6 11.5 1.6C83.5 1.1 78.2 0 72.1 0c-.7 0-1.5 0-2.2.1-20.4.9-37.1 10-50.9 27.8C6.2 44.3-.2 63 0 83.2c.2 19.7 8.2 32.3 23.2 36.8-12.3-5.6-19.6-17.5-19.7-35.2"
            className="trusted-shops_svg__st6"
          />
          <path
            id="trusted-shops_svg__Path_15_"
            d="M52 111.7c9.1 0 15-5.1 20.2-9.2 6.5-5.1 12.6-11.9 16.9-17.8l-2.8-2.3-.9 1.4c-4.4 6.1-9.6 12.3-16.3 17.6-5.2 4.1-12.3 8.6-21.4 8.6-1.1 0-2.1-.2-3.2-.3-.7-.1-2.2-.5-2.8-.7 1.9 1 4.6 2.2 7 2.5 1.1.1 2.2.2 3.3.2"
            className="trusted-shops_svg__st6"
          />
          <path
            id="trusted-shops_svg__Path_16_"
            d="M80.4 23.2C81 34.2 74.8 44 62 52.4c-8 5.3-17.9 9.3-28.9 11.7-.2.9-.1.4-.2 1.2C45.8 63 57.2 60 66.4 53.9c12.7-8.4 18.9-18.3 18.4-29.2-.3-6.5-4.2-11.2-10.1-12.2 3.3 2.1 5.4 5.9 5.7 10.7"
            className="trusted-shops_svg__st6"
          />
        </g>
      </g>
    </g>
  </svg>
);
